import { useState } from "react";
import api from "../api/api";

function Login() {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const login = async () => {
    if (!phone || !password) {
      setError("Please enter phone and password");
      return;
    }
    setError("");
    setLoading(true);
    try {
      const res = await api.post("/auth/login", { phone, password });

      if (!res.data.success) {
        setError(res.data.message || "Login failed");
        return;
      }

      const data = res.data.data;
      localStorage.setItem("accessToken", data.accessToken);
      localStorage.setItem("refreshToken", data.refreshToken);
      localStorage.setItem("role", data.role);
      localStorage.setItem("userName", data.name || "User");

      if (data.role === "ROLE_ADMIN")        window.location.href = "/admin";
      else if (data.role === "ROLE_VENDOR")  window.location.href = "/vendor";
      else                                   window.location.href = "/dashboard";

    } catch {
      setError("Invalid phone number or password");
    } finally {
      setLoading(false);
    }
  };

  const handleKey = (e) => { if (e.key === "Enter") login(); };

  return (
    <div className="login-page">
      {/* ── LEFT PANEL ─────────────────────────────── */}
      <div className="login-left">
        <div style={{ fontSize: 36, marginBottom: 10 }}>📰</div>

        <div className="login-headline">
          The <span>Press</span><br />
          Management<br />
          System
        </div>

        <div className="login-divider" />

        <div className="login-tagline">
          Manage newspaper delivery operations with precision.
          Track vendors, subscriptions, payments and deliveries —
          all from one elegant dashboard.
        </div>

        <div className="login-stats">
          {[
            ["📦", "500+", "Deliveries/day"],
            ["📰", "12",   "Newspapers"],
            ["👥", "1,200+","Subscribers"],
          ].map(([icon, val, lbl]) => (
            <div key={lbl}>
              <div style={{ fontSize: 22 }}>{icon}</div>
              <div className="login-stat-num">{val}</div>
              <div className="login-stat-lbl">{lbl}</div>
            </div>
          ))}
        </div>
      </div>

      {/* ── RIGHT PANEL ────────────────────────────── */}
      <div className="login-right">
        <div className="login-form-title">Welcome back</div>
        <div className="login-form-sub">Sign in to your dashboard</div>

        {error && (
          <div className="alert alert-error">⚠ {error}</div>
        )}

        <div className="login-form">
          <div className="form-group">
            <label className="form-label">Phone Number</label>
            <div className="input-with-icon">
              <span className="input-icon">📱</span>
              <input
                className="form-input"
                placeholder="10-digit mobile number"
                value={phone}
                onChange={e => setPhone(e.target.value)}
                onKeyDown={handleKey}
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <div className="input-with-icon">
              <span className="input-icon">🔒</span>
              <input
                className="form-input"
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                onKeyDown={handleKey}
              />
            </div>
          </div>

          <button
            className="btn btn-primary btn-lg btn-block"
            onClick={login}
            disabled={loading}
            style={{ marginTop: 6 }}
          >
            {loading ? "Signing in…" : "Sign In →"}
          </button>
        </div>

        <div className="login-footer-text">
          New subscriber?{" "}
          <a href="/register" className="text-link">Register here</a>
        </div>
      </div>
    </div>
  );
}

export default Login;
